import {I18n} from '@aws-amplify/core';

import {FlexiButton,} from '@flexinet/ui-components';
import {useUserAccount} from "../../../../hooks/useUserAccount.ts";
import {useAccountApplication} from "../../account-applications/hooks/useAccountApplication";
import {AccountApplication} from "../../account-applications/types";
import {AiOutlineClose} from "react-icons/ai";

export const DisableRecordButton = ({
                                        record
                                    }: {
    record: AccountApplication
}) => {

    const {userAccount} = useUserAccount();

    if (!userAccount) {
        throw new Error('User account not found');
    }

    const {updateRecord} = useAccountApplication(userAccount.id, record.id)

    // FNP-795: "Disable" now DEACTIVATES. It used to call deleteRecord() — a button
    // labelled Disable that destroyed the row.
    //
    // That is no longer merely misleading, it is broken: an AccountApplication row
    // with status ACTIVE is an occupied SEAT, and console-api now REJECTS deleting
    // one, because the delete would destroy the deactivation timestamp prorated
    // seat-time billing is computed from — a value that cannot be reconstructed from
    // anywhere afterwards.
    //
    // This is also the ONLY seat-release affordance in the portal: no form here
    // exposes accountApplicationStatus, and the applications list does not display
    // it. Left as a delete, a portal user would hit an error telling them to
    // "deactivate first" with no way in the entire app to do so. Flipping the status
    // is what the button always claimed to do, and it is what billing needs to
    // observe — the deactivate emits the seat-occupancy-stopped event that closes
    // the occupancy interval.
    //
    // Delete is still available for genuine cleanup once a row is INACTIVE.
    const onClick = () => {
        updateRecord({
                         ...record,
                         accountApplicationStatus: 'INACTIVE',
                     } as AccountApplication);
    };
    return (
        <FlexiButton
            variant={'subtle'}
            leftSection={<AiOutlineClose/>}
            onClick={onClick}
            size={'md'}
        >
            {I18n.get('Disable')}
        </FlexiButton>
    );
};
